






























































































import Vue, { PropType } from "vue"
import { OUTLINED } from "~/components/guideline/icon/MaterialIcon.vue"
import EditLinkIcon from "~/components/guideline/icon/EditLinkIcon.vue"
import TagList from "~/components/guideline/tag/TagList.vue"
import TagListItem from "~/components/guideline/tag/TagListItem.vue"
import EditItemDescription from "~/components/guideline/util/EditItemDescription.vue"
import { priceFormat } from "~/plugins/priceFormatter"
import {
  RewardType,
  convertRewardTypeToLabel,
} from "~/backendApis/viewModel/userProfile"
const baseInfoEditFormPath = "/profiles/edit/base"
const jobEditFormPath = "/profiles/edit/job"
const workStyleEditFormPath = "/profiles/edit/work_style"

export default Vue.extend({
  components: {
    EditLinkIcon,
    TagList,
    TagListItem,
    EditItemDescription,
  },
  props: {
    fullName: {
      type: String,
      required: true,
    },
    prefectureName: {
      type: String,
      required: true,
    },
    workingFormName: {
      type: String,
      required: true,
    },
    corporationName: {
      type: String,
      default: null,
    },
    // 企業が在籍中の企業かどうかを示すフラグ
    isCurrentCorporation: {
      type: Boolean,
      default: null,
    },
    mainJob: {
      type: String,
      required: true,
    },
    subJob: {
      type: String,
      default: null,
    },
    availableUptimeName: {
      type: String,
      required: true,
    },
    availableHoursPerDay: {
      type: Number,
      default: null,
    },
    contactableTypeNames: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    rewardType: {
      type: String,
      default: null,
    },
    minReward: {
      type: Number,
      default: null,
    },
    maxReward: {
      type: Number,
      default: null,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      iconType: {
        OUTLINED,
      },
    }
  },
  computed: {
    baseInfoEditLinkPath(): string | null {
      return this.isEditable ? baseInfoEditFormPath : null
    },
    jobEditLinkPath(): string | null {
      return this.isEditable ? jobEditFormPath : null
    },
    workStyleEditLinkPath(): string | null {
      return this.isEditable ? workStyleEditFormPath : null
    },
    isInputMainJob() {
      return !!(this.mainJob === "" && this.isEditable === true)
    },
    isInputWorkStyle() {
      return (
        !(this.workingFormName && this.availableUptimeName) && this.isEditable
      )
    },
    availableUptimeAndHoursPerDayName(): string {
      return this.availableHoursPerDay
        ? `${this.availableUptimeName} ${this.availableHoursPerDay}時間/日`
        : String(this.availableUptimeName)
    },
    desiredRewardRange(): string {
      return this.rewardType
        ? `${
            this.rewardType === "negotiable" ? "希望単価：" : ""
          }${convertRewardTypeToLabel(this.rewardType as RewardType)} ${
            this.rewardType === "hourly"
              ? `${this.minReward.toLocaleString()}円~`
              : this.rewardType === "monthly"
              ? `${priceFormat(Number(this.minReward))}円~`
              : ""
          }`
        : ""
    },
  },
})
